import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form theme-form" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = { class: "mb-3 nav-item" }
const _hoisted_4 = { class: "d-flex nav nav-pills main-menu email-category" }
const _hoisted_5 = { class: "mb-3 nav-item" }
const _hoisted_6 = { class: "mb-3 nav-item" }
const _hoisted_7 = { class: "mb-3 nav-item" }
const _hoisted_8 = { class: "mb-3 nav-item" }
const _hoisted_9 = { class: "mb-3 nav-item" }
const _hoisted_10 = { class: "mb-3 nav-item" }
const _hoisted_11 = { class: "mb-3 nav-item" }
const _hoisted_12 = { class: "mb-3 nav-item" }
const _hoisted_13 = { class: "mb-3 nav-item" }
const _hoisted_14 = { class: "mb-3 nav-item" }
const _hoisted_15 = { class: "p-3" }
const _hoisted_16 = { class: "text-end mt-3" }

import { computed, onMounted } from 'vue'
import { useRoute } from 'vue-router';

import { useProductsStore } from '@/store/management/productsStore';
import Swal from 'sweetalert2'
import router from '@/router';


export default /*@__PURE__*/_defineComponent({
  __name: 'productDetails',
  setup(__props) {

const productStore = useProductsStore()
const route = useRoute()

const currentProductID = computed(() => {
    return Array.isArray(route.params.id) ? route.params.id[0] : route.params.id
})

const activeProduct = computed(() => {
    return productStore.getActiveProduct
})

const tempActiveProduct = computed(() => {
    return productStore.getTempActiveProduct
})


const save = () => {
    console.log(tempActiveProduct.value);
    productStore.updateProduct(tempActiveProduct.value);
    Swal.fire({
        icon: "success",
        title: "success!",
        text: "Tax details updated successfully",
        confirmButtonColor: 'var(--theme-default)',
    }).then(() => {
        console.log(productStore.getAllProducts('all', ''));
        router.push('/management/products');
    });
}

const onRemove = () => {
    Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#ff0000', // Red color for confirm button
        cancelButtonColor: '#dfdfdf', // Black color for cancel button
        confirmButtonText: 'Confirm',
    }).then((result) => {
        if (result.isConfirmed) {
            productStore.removeProduct(activeProduct.value.basic.productNumber)
            Swal.fire(
                'Deleted!',
                'Your file has been deleted.',
                'success'
            )
        }
    }).then(() => {
        router.push('/management/products')
    })
}

onMounted(() => {
    const currentProductNumber = Array.isArray(route.params.id) ? route.params.id[0] : route.params.id
    const currentProductData = productStore.getProductDataById(currentProductNumber)
    if (currentProductData) {
        productStore.initActiveProduct(currentProductData)
    } else {
        router.push('/management/products')
    }
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("h4", _hoisted_3, [
          _createVNode(_component_router_link, {
            class: _normalizeClass(["nav-link", { active: _unref(route).path === `/management/products` }]),
            to: `/management/products`
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createElementVNode("i", { class: "fa fa-arrow-left" }, null, -1),
              _createTextVNode(" Product List")
            ])),
            _: 1
          }, 8, ["class"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h4", _hoisted_5, [
            _createVNode(_component_router_link, {
              class: _normalizeClass(["nav-link", { active: _unref(route).path === `/management/products/details/${currentProductID.value}` }]),
              to: `/management/products/details/${currentProductID.value}`
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode("Basic")
              ])),
              _: 1
            }, 8, ["to", "class"])
          ]),
          _createElementVNode("h4", _hoisted_6, [
            _createVNode(_component_router_link, {
              class: _normalizeClass(["nav-link", { active: _unref(route).path.includes('/management/products/details/stock/') }]),
              to: `/management/products/details/stock/${currentProductID.value}`
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createTextVNode("Stock")
              ])),
              _: 1
            }, 8, ["to", "class"])
          ]),
          _createElementVNode("h4", _hoisted_7, [
            _createVNode(_component_router_link, {
              class: _normalizeClass(["nav-link", { active: _unref(route).path.includes('/management/products/details/scale/') }]),
              to: `/management/products/details/scale/${currentProductID.value}`
            }, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [
                _createTextVNode("Scale")
              ])),
              _: 1
            }, 8, ["to", "class"])
          ]),
          _createElementVNode("h4", _hoisted_8, [
            _createVNode(_component_router_link, {
              class: _normalizeClass(["nav-link", { active: _unref(route).path.includes('/management/products/details/set_items/') }]),
              to: `/management/products/details/set_items/${currentProductID.value}`
            }, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [
                _createTextVNode("Set Items")
              ])),
              _: 1
            }, 8, ["to", "class"])
          ]),
          _createElementVNode("h4", _hoisted_9, [
            _createVNode(_component_router_link, {
              class: _normalizeClass(["nav-link", { active: _unref(route).path.includes('/management/products/details/appearance/') }]),
              to: `/management/products/details/appearance/${currentProductID.value}`
            }, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [
                _createTextVNode("Appearance")
              ])),
              _: 1
            }, 8, ["to", "class"])
          ]),
          _createElementVNode("h4", _hoisted_10, [
            _createVNode(_component_router_link, {
              class: _normalizeClass(["nav-link", { active: _unref(route).path.includes('/management/products/details/price_levels/') }]),
              to: `/management/products/details/price_levels/${currentProductID.value}`
            }, {
              default: _withCtx(() => _cache[8] || (_cache[8] = [
                _createTextVNode("Price Levels")
              ])),
              _: 1
            }, 8, ["to", "class"])
          ]),
          _createElementVNode("h4", _hoisted_11, [
            _createVNode(_component_router_link, {
              class: _normalizeClass(["nav-link", { active: _unref(route).path.includes('/management/products/details/condiments/') }]),
              to: `/management/products/details/condiments/${currentProductID.value}`
            }, {
              default: _withCtx(() => _cache[9] || (_cache[9] = [
                _createTextVNode("Condiments")
              ])),
              _: 1
            }, 8, ["to", "class"])
          ]),
          _createElementVNode("h4", _hoisted_12, [
            _createVNode(_component_router_link, {
              class: _normalizeClass(["nav-link", { active: _unref(route).path.includes('/management/products/details/link_groups/') }]),
              to: `/management/products/details/link_groups/${currentProductID.value}`
            }, {
              default: _withCtx(() => _cache[10] || (_cache[10] = [
                _createTextVNode("Link Groups")
              ])),
              _: 1
            }, 8, ["to", "class"])
          ]),
          _createElementVNode("h4", _hoisted_13, [
            _createVNode(_component_router_link, {
              class: _normalizeClass(["nav-link", { active: _unref(route).path.includes('/management/products/details/variation/') }]),
              to: `/management/products/details/variation/${currentProductID.value}`
            }, {
              default: _withCtx(() => _cache[11] || (_cache[11] = [
                _createTextVNode("Variation")
              ])),
              _: 1
            }, 8, ["to", "class"])
          ]),
          _createElementVNode("h4", _hoisted_14, [
            _createVNode(_component_router_link, {
              class: _normalizeClass(["nav-link", { active: _unref(route).path.includes('/management/products/details/miscellaneous/') }]),
              to: `/management/products/details/miscellaneous/${currentProductID.value}`
            }, {
              default: _withCtx(() => _cache[12] || (_cache[12] = [
                _createTextVNode("Miscellaneous")
              ])),
              _: 1
            }, 8, ["to", "class"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_router_view)
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("a", {
        class: "btn btn-danger me-3 px-2",
        style: {"width":"144px"},
        target: "_blank",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (onRemove()))
      }, "Delete"),
      _createElementVNode("a", {
        class: "btn btn-success me-3 px-2",
        style: {"width":"144px"},
        target: "_blank",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (save()))
      }, "Modify / Save")
    ])
  ]))
}
}

})